"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ColorPickerSlider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../../theme/utils/useTheme");
var _constrainValue = require("../../../colorPickerUtils/constrainValue");
var _ColorPickerSliderButton = require("./styled/ColorPickerSliderButton");
var _ColorPickerSliderRail = require("./styled/ColorPickerSliderRail");
var _ColorPickerSliderRoot = require("./styled/ColorPickerSliderRoot");
const ColorPickerSlider = _ref => {
  let {
    color,
    maxValue,
    onChange,
    type,
    value,
    buttonColor,
    className,
    clientId
  } = _ref;
  const [positionState, setPositionState] = (0, _react.useState)((0, _constrainValue.constrainValue)(0, 1, value / maxValue));
  const trackRef = (0, _react.useRef)(null);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const setPosition = (0, _react.useCallback)(function (p) {
    let dispatchChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const position = (0, _constrainValue.constrainValue)(0, 1, p);
    setPositionState(position);
    if (dispatchChange) {
      onChange(maxValue * position);
    }
  }, [onChange, maxValue]);
  const getMousePosition = e => {
    const trackRect = trackRef.current?.getBoundingClientRect();
    if (trackRect) {
      const x = (e.clientX - trackRect.left) / trackRect.width;
      return x;
    }
  };
  const onMouseDown = event => {
    onMouseMove(event);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", cleanUp);
  };
  const onMouseMove = (0, _react.useCallback)(e => {
    const position = getMousePosition(e);
    position && setPosition(position);
  }, [setPosition]);
  const cleanUp = (0, _react.useCallback)(() => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", cleanUp);
  }, [onMouseMove]);
  const onKeyDown = e => {
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        setPosition(positionState + (e.shiftKey ? 0.05 : 0.01));
        break;
      case "ArrowLeft":
      case "ArrowDown":
        setPosition(positionState - (e.shiftKey ? 0.05 : 0.01));
        break;
      default:
        return e;
    }
  };
  (0, _react.useEffect)(() => {
    setPosition(value / maxValue, false);
  }, [value, maxValue, setPosition]);
  (0, _react.useEffect)(() => {
    return cleanUp();
  }, [cleanUp]);
  return /*#__PURE__*/_react.default.createElement(_ColorPickerSliderRoot.ColorPickerSliderRoot, {
    className: className,
    "data-client-id": clientId,
    draggable: false,
    tabIndex: -1,
    "aria-hidden": true,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_ColorPickerSliderRail.ColorPickerSliderRail, {
    ref: trackRef,
    type: type,
    color: color,
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    draggable: false,
    role: "slider"
  }), /*#__PURE__*/_react.default.createElement(_ColorPickerSliderButton.ColorPickerSliderButton, {
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, `${type}-slider-btn`),
    draggable: false,
    style: {
      left: `${positionState * 100}%`,
      backgroundColor: buttonColor || color
    }
  }));
};
exports.ColorPickerSlider = ColorPickerSlider;
var _default = ColorPickerSlider;
exports.default = _default;
//# sourceMappingURL=ColorPickerSlider.js.map